import type {SVGProps} from 'react';

export function Fa7SolidBold(props: SVGProps<SVGSVGElement>) {
    return (<svg xmlns="http://www.w3.org/2000/svg" width={"1em"} height={"1em"} viewBox="0 0 640 640" {...props}>
        <path fill="currentColor"
              d="M160 96c-17.7 0-32 14.3-32 32s14.3 32 32 32h32v320h-32c-17.7 0-32 14.3-32 32s14.3 32 32 32h224c70.7 0 128-57.3 128-128c0-46.5-24.8-87.3-62-109.7c18.7-22.3 30-51 30-82.3c0-70.7-57.3-128-128-128zm256 128c0 35.3-28.7 64-64 64h-96V160h96c35.3 0 64 28.7 64 64M256 480V352h128c35.3 0 64 28.7 64 64s-28.7 64-64 64z"></path>
    </svg>);
}